    // pages/PrivacyPolicyPage.js
    import React from 'react';
    import PrivacyPolicy from './PrivacyPolicy';

    const PrivacyPolicyPage = () => {
      return (
        <div className="privacy-policy-container">
          <PrivacyPolicy />
        </div>
      );
    };

    export default PrivacyPolicyPage;